export class DeleteUserINModel {
    idUser: number
}